export const FETCH_PARTNERS = 'FETCH_PARTNERS';
export const PARTNER_BY_ID = 'PARTNER_BY_ID';
export const FETCH_PARTNERS_FOR_SELECT = 'FETCH_PARTNERS_FOR_SELECT';
export const FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2C =
  'FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2C';
export const FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2B =
  'FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2B';
export const FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY = 'FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY';
export const FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2C =
  'FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2C';
export const FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2B =
  'FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2B';
export const FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL =
  'FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL';
export const OPERATION_BY_ID_B2C = 'OPERATION_BY_ID_B2C';
export const OPERATION_BY_ID_B2B = 'OPERATION_BY_ID_B2B';
export const UPDATE_OPERATIONS_B2C = 'UPDATE_OPERATIONS_B2C';
export const UPDATE_OPERATIONS_B2B = 'UPDATE_OPERATIONS_B2B';
export const UPDATE_EXPIRATIONS = 'UPDATE_EXPIRATIONS';
export const UPDATE_OPERATION_SELECT = 'UPDATE_OPERATION_SELECT';
export const DELETE_OPERATION_BY_ID = 'DELETE_OPERATION_BY_ID';
export const SET_PARTNERS_PROPERTY = 'SET_PARTNERS_PROPERTY';
export const CREATE_NEW_PARTNER = 'CREATE_NEW_PARTNER';
export const FETCH_PARTNERS_THEMES = 'FETCH_PARTNERS_THEMES';
export const FETCH_PARTNER_BY_ID = 'FETCH_PARTNER_BY_ID';
